import { Container, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

export interface HeaderMessageProps {
  title: string;
  message: string;
  color: "warning" | "error" | "success" | "info" | "primary" | "secondary";
}

export const HeaderMessage: FC<HeaderMessageProps> = ({
  title,
  message,
  color,
}) => {
  const theme = useTheme();
  const backgroundColor = theme.palette[color].main;
  const textColor = theme.palette[color].contrastText;

  return (
    <Stack
      mt={0}
      direction="row"
      alignItems="center"
      sx={{
        backgroundColor: backgroundColor,
        height: "70px",
        boxShadow: (theme) => theme.shadows[1],
      }}
    >
      <Container maxWidth={"xxl"}>
        <Typography
          component={"h5"}
          fontWeight={700}
          fontSize="var(--title-t2-18-regular-size, 18px)"
          color={textColor}
        >
          {title}
        </Typography>
        <Typography
          component="span"
          fontSize="var(--cf-local-13-size, 13px)"
          color={textColor}
        >
          {message}
        </Typography>
      </Container>
    </Stack>
  );
};
